import { Component, Input } from '@angular/core';

export interface InfoData {
  rp_cod: string;
  rp: string;
  ra_cod: number;
  ra: string;
  cod_bairro: number;
  bairro: string;
  favela: string;
  morfologia: string;
  cat_entrada: string;
  tipo_entrada: string;
  grau_entrada: string;
}

@Component({
  selector: 'app-information',
  standalone: true,
  imports: [],
  templateUrl: './information.component.html',
  styleUrl: './information.component.scss'
})


export class InformationComponent {
  @Input() information: any
  constructor() { }

}
